import { render, staticRenderFns } from "./ContenidoModal.vue?vue&type=template&id=811a409a&"
import script from "./ContenidoModal.vue?vue&type=script&lang=ts&"
export * from "./ContenidoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports